import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { HandlerManager } from 'src/app/managers/handler/handler.manager';
import { LoadingManager } from 'src/app/managers/loading/loading.manager';
import { SessionManager  } from 'src/app/managers/session/session.manager';
import { Site            } from 'src/app/beans/site/site.bean';
import { User            } from 'src/app/beans/login/user/user.bean';
import { Dashboard       } from 'src/app/beans/dashboard/dashboard';
import { DashboardTicket } from 'src/app/beans/dashboard/dashboard.ticket';
import { DashboardBook   } from 'src/app/beans/dashboard/dashboard.book';

@Component
({
  selector     : 'accordion-table',
  templateUrl  : './accordion.table.html',
  styleUrls    : ['./accordion.table.scss']
})

export class AccordionTable implements OnInit 
{  
  @Input() title : string
  
  private siteId: number;
  private type  : number;

  fields: string[] 
  data  : any   [] = [] 

  values: Dashboard;
  disabled = false;

  @Input( 'site' ) set _site( site: Site )
  {  
    if( site ){
      this.siteId = site.id
      this.init()
    }
  }

  @Input( 'type' ) set _type( type: number )
  {   
    if( type ){
      this.type = type
      this.init()
    } 
  }
  
  constructor
  (
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
  ) {}

  ngOnInit(): void
  {

  }

  async init()
  {
      if( this.siteId && this.type )
      {
          this.values = await this.retriveValues( this.siteId, this.type )

          if( !this.values ) return

          let ticket = null, book = null

          if( this.values.ticket ) ticket = this.values.ticket
          if( this.values.book   ) book   = this.values.book

          //Choose table to populate
          switch(this.title)
          {
            case "Sito"     : this.setSiteData   (ticket, book); break;
            case "Sportelli": this.setCounterData(ticket, book); break;
            case "Servizi"  : this.setServiceData(ticket, book); break;
          }
      }    
  }

  setSiteData(ticket: DashboardTicket, book: DashboardBook)
  {
    //Reset data
    this.data   = []
    this.fields = []

    //Set ticket data
    if( ticket.sites[0] )
    {
      let fieldName = Object.keys( ticket.sites[0] );

      for( var name of fieldName )
      {
        this.fields.push("table.fields." + name)
      }

      for (var value of ticket.sites)
      {
        value["type"] = "Ticket"
        this.data.push(Object.values(value))
      }
    }
    //Set book data
    if ( book.sites[0] )
    {
      if( !this.fields || !ticket.sites[0] )
      {
        let fieldName = Object.keys( book.sites[0] );

        for( var name of fieldName )
        {
          this.fields.push("table.fields." + name)
        }
      }

      for (var value of book.sites)
      {
        value["type"] = "Book"
        this.data.push(Object.values(value))
      }
    }
  }

  setCounterData(ticket: DashboardTicket, book: DashboardBook)
  {
    //Reset data
    this.data   = []
    this.fields = []

    //Set ticket data
    if( ticket.counters[0] )
    {
      let fieldName = Object.keys( ticket.counters[0] );

      for( var name of fieldName )
      {
        this.fields.push("table.fields." + name)
      }

      for (var value of ticket.counters)
      {
        value["type"] = "Ticket"
        this.data.push(Object.values( value ))
      }
    }
    //Set book data
    if ( book.counters[0] )
    {
      if( !this.fields || !ticket.counters[0] )
      {
        let fieldName = Object.keys( book.counters[0] );

        for( var name of fieldName )
        {
          this.fields.push("table.fields." + name)
        }
      }

      for (var value of book.counters)
      {
        value["type"] = "Book"
        this.data.push(Object.values( value ))
      }
    }
  }

  setServiceData(ticket: DashboardTicket, book: DashboardBook)
  {
    //Reset data
    this.data   = []
    this.fields = []

    //Set ticket data
    if( ticket.services[0] )
    {
      let fieldName = Object.keys( ticket.services[0] );

      for( var name of fieldName )
      {
        this.fields.push("table.fields." + name)
      }

      for (var value of ticket.services)
      {
        value["type"] = "Ticket"
        this.data.push(Object.values(value))
      }
    }
    //Set book data
    if ( book.services[0] )
    {
      if( !this.fields || !ticket.services[0] )
      {
        let fieldName = Object.keys( book.services[0] );

        for(var name of fieldName ){
          this.fields.push("table.fields." + name)
        }
      }

      for (var value of book.services)
      {
        value["type"] = "Book"
        this.data.push(Object.values(value))
      }
    }
  }

  async retriveValues( siteId: number, type: number)
  {
    const user  = this._session.user().get()

    if (!User.isKind( user )) return // TODO handle user incorrect 

    this._loader.start()

    let response = await this._handler.dashboard().getAll(( user as User ).token, siteId, type )

    this._loader.stop()

    if ( !response ) return 

    return response as Dashboard;
  }
}
